module.exports = __webpack_public_path__ + "img/tut_yes.622b6694.png";